import sraped from "./layers/sticker2.png";
import logoBG from "./layers/Sraped.png";
import React, { useEffect, useState } from "react";

export default function StickerSVG(props) {
  const [filter, setFilter] = useState(null);

  useEffect(() => {
    const rgb = hexToRgb(props.color);
    const filterValue = `${rgb.r / 255} 0 0 0 0  0 ${rgb.g / 255} 0 0 0  0 0 ${rgb.b / 255
      } 0 0  0 0 0 1 0`;
    setFilter(filterValue);
    function hexToRgb(hex) {
      if (hex.length === 4) {
        hex = "#" + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
      }
      const bigint = parseInt(hex.slice(1), 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;

      return { r, g, b };
    }
  }, [props.color]);

  const Page = ({ cols, rows }) => {
    function Row({row}) {
      var colsArray = [];
      for (let i = 0; i < cols; i++) {
        colsArray.push(
          <>
          <circle
              cx={(28.5 + i*8)+"%"}
              cy={(28 + row*8)+"%"}
              r="3%"
              fill={"#fff"}
              filter="url(#stcolorize)"
            />
            <image
              width={
                props.logoSize === "medium"
                  ? "5.6%"
                  : props.logoSize === "small"
                    ? "5.2%"
                    : "5.8%"
              }
              height={
                props.logoSize === "medium"
                  ? "5.6%"
                  : props.logoSize === "small"
                    ? "5.2%"
                    : "5.8%"
              }
              xlinkHref={props.logo}
              x={
                props.logoSize === "medium"
                  ? (25.7 + i*8)+"%"
                  : props.logoSize === "small"
                    ? (25.9 + i*8)+"%"
                    : (25.6 + i*8)+"%"
              }
              y={
                props.logoSize === "medium"
                  ? (25.2 + row*8)+"%"
                  : props.logoSize === "small"
                    ? (25.4 + row*8)+"%"
                    : (25.1 + row*8)+"%"
              }
            />
          </>
        );
      }
      return <g>{colsArray}</g>;
    }
    var rowArray = []
    for (var j = 0; j < rows; j++) {
      rowArray.push(<Row row={j} />)
    }
    return <g>{rowArray}</g>;
  };

  return (
    <svg
      version="1.2"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      className="svgProduct hover-magnify"
    >
      <title>4 Gift Srapping Stickers v1</title>
      <defs>
        <image width="30%" id="stimg1" href={logoBG} />
        <image width="30%" id="stimg2" href={sraped} />
      </defs>
      <style></style>
      <g id="Gift Srapping Stickers">
        <rect
          width="50%"
          height="72%"
          x="20%"
          y="20%"
          style={{ fill: "#fff" }}
        />
        <Page rows={8} cols={5} />
        <use
          id="BIG_STICKER_BG"
          style={{ filter: `url(#stcolorize)` }}
          href="#stimg1"
          x="55%"
          y="5%"
        />
        <image
          width={
            props.logoSize === "medium"
              ? "26.5%"
              : props.logoSize === "small"
                ? "25%"
                : "27%"
          }
          height={
            props.logoSize === "medium"
              ? "23.5%"
              : props.logoSize === "small"
                ? "23%"
                : "24%"
          }
          xlinkHref={props.logo}
          x={
            props.logoSize === "medium"
              ? "56.9%"
              : props.logoSize === "small"
                ? "57.8%"
                : "56.65%"
          }
          y={
            props.logoSize === "medium"
              ? "7.9%"
              : props.logoSize === "small"
                ? "8.1%"
                : "7.6%"
          }
        />
        <use id="STICKER" href="#stlogo" />
        <use id="STICKER" href="#stimg2" x="55%" y="5%" />
      </g>
      <filter id="stcolorize">
        <feColorMatrix type="matrix" values={filter} />
      </filter>
    </svg>
  );
}
